<template>
  <RevTable :collection :columns :transparent-header="withoutHeader" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { GetSellerProductDetails } from '@backmarket/http-api/src/api-specs-catalog/catalog-access/products.types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTable } from '@ds/components/Table'

import { FALLBACK_VALUE } from './ProductAttributesTable.constants'
import translations from './ProductAttributesTable.translations'

const props = defineProps<{
  productDetails: GetSellerProductDetails
  withoutHeader: boolean
}>()

const i18n = useI18n()

const columns = [
  { key: 'attribute', label: i18n(translations.tableHeadersAttributes) },
  { key: 'value', label: i18n(translations.tableHeadersValues) },
]

const collection = computed(() => [
  {
    attribute: i18n(translations.categoryName),
    value: props.productDetails.category?.name || FALLBACK_VALUE,
  },
  {
    attribute: i18n(translations.categoryId),
    value:
      props.productDetails.category?.marketplaceCategoryId || FALLBACK_VALUE,
  },
  {
    attribute: i18n(translations.attributeNameBrand),
    value: props.productDetails.brand || FALLBACK_VALUE,
  },
  {
    attribute: i18n(translations.attributeNameEan),
    value: props.productDetails.ean || FALLBACK_VALUE,
  },
  {
    attribute: i18n(translations.attributeNameHeight),
    value: props.productDetails.height || FALLBACK_VALUE,
  },
  {
    attribute: i18n(translations.attributeNameWidth),
    value: props.productDetails.width || FALLBACK_VALUE,
  },
  {
    attribute: i18n(translations.attributeNameWeight),
    value: props.productDetails.weight || FALLBACK_VALUE,
  },
  {
    attribute: i18n(translations.attributeNameDepth),
    value: props.productDetails.depth || FALLBACK_VALUE,
  },
  ...props.productDetails.categoryAttributes.map(
    ({ displayName, fieldName }) => ({
      attribute: displayName,
      value: props.productDetails.productFields[fieldName] || FALLBACK_VALUE,
    }),
  ),
])
</script>
